import { render, staticRenderFns } from "./ItemPriceType.vue?vue&type=template&id=100b4e21"
import script from "./ItemPriceType.vue?vue&type=script&lang=js"
export * from "./ItemPriceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('100b4e21')) {
      api.createRecord('100b4e21', component.options)
    } else {
      api.reload('100b4e21', component.options)
    }
    module.hot.accept("./ItemPriceType.vue?vue&type=template&id=100b4e21", function () {
      api.rerender('100b4e21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/logistics/strategy/orderMoney/components/ItemPriceType.vue"
export default component.exports